export const SPECIFICITY_OPTIONS = [
  { key: 'AUTO', label: 'Auto' },
  { key: 'ASSISTANCE_CHAISE_ROULANTE', label: 'Assistance : Chaise Roulante' },
  { key: 'PREVENIR_HANDICAP', label: 'Prévenir handicap' },
  { key: 'RECONTACTER_AGENCE', label: 'Recontacter agence' },
  { key: 'TEXTE_LIBRE', label: 'Texte Libre' },
  { key: 'DEMANDE_SIEGE_BAGAGE_ANIMAUX', label: 'Demande de siège / bagage en plus / animaux' },
  { key: 'UM_JEUNE_12_17', label: 'UM jeune 12-17 ans' },
] as const

export interface BookingSpecificityDetail {
  bookingId: string
  id: string
  freeText: null | string
  options: string[]
  createdAt: string
}

export interface CreateBookingSpecificityPayload {
  freeText?: string
  options: SpecificityOptionKey[]
}

export type SpecificityOptionKey = (typeof SPECIFICITY_OPTIONS)[number]['key']
